import { render, staticRenderFns } from "./RepackingDetailUpload.vue?vue&type=template&id=1233c739&"
import script from "./RepackingDetailUpload.vue?vue&type=script&lang=js&"
export * from "./RepackingDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports